/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import api from 'api';

import LoginMfaPresenter from './LoginMfa.presenter';

import routeNames from 'lib/routeNames';
import AppUtils from 'lib/AppUtils';
import userActions from 'redux/actions/user';
import navigationActions from 'redux/actions/navigation';
import sessionActions from 'redux/actions/session';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser: (user) => {
      dispatch(userActions.receive(user));
    },
    loginSuccessful: (accessToken) => {
      dispatch(sessionActions.loginSuccessful(accessToken));
      dispatch(navigationActions.replace(routeNames.home()));
    },
    logout: () => {
      dispatch(sessionActions.logout());
      dispatch(navigationActions.goBackTo(routeNames.loginEmail()));
    },
  }
}

class LoginMfa extends React.Component {

  constructor(props) {
    super(props);

    this.loginWithMfa = this.loginWithMfa.bind(this);
  }

  loginWithMfa(mfaCode) {
    return api.sessionApi.mfaLogin(mfaCode, 'short')
    .then((accessToken) => {
      const user = accessToken.user;
      this.props.updateUser(user);
      return accessToken;
    }).then((accessToken) => {
      this.props.loginSuccessful(accessToken);
    });
  }

  render() {
    return (
      <LoginMfaPresenter
        loginWithMfa={this.loginWithMfa}
        logout={this.props.logout}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginMfa);
